<template>
  <div>
    <v-card
      :loading="loading"
      rounded="lg"
      class="animate__animated animate__fadeInUp"
    >
      <v-toolbar class="elevation-0">
        <v-toolbar-title>
          <lord-icon
            src="https://cdn.lordicon.com/cfoaotmk.json"
            trigger="loop"
            colors="primary:#545454,secondary:#16a9c7"
            style="width: 50px; height: 50px"
          >
          </lord-icon>
          ผู้เรียน (คน)
          {{ numberWithCommas(totalStudents) }}
          <div v-if="entranceYear" class="caption grey--text">
            ข้อมูล ณ ปีการศึกษา {{ entranceYear }}
          </div>
        </v-toolbar-title>

        <v-spacer></v-spacer>
      </v-toolbar>
      <div id="chart" v-if="loading === false && totalStudents > 0">
        <apexchart type="pie" :options="chartOptions" :series="series">
        </apexchart>
      </div>
      <v-card-text v-else-if="loading === false" class="text-center grey--text">
        ไม่พบข้อมูลนักเรียนของสถานศึกษานี้
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'OcsMasterMouchartdonut',

  data() {
    return {
      ApiKey: 'HRvec2021',
      loading: true,
      series: [],
      totalStudents: 0,
      entranceYear: null,
      chartOptions: {
        chart: {
          type: 'pie',
        },
      },
    }
  },

  async mounted() {
    await this.queryStudentStatSummary()
  },

  methods: {
    numberWithCommas(x) {
      x = String(x)
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
      return x
    },

    async queryStudentStatSummary() {
      try {
        this.loading = true
        let result = await this.$http
          .post('student_stat_summary_college.php', {
            ApiKey: this.ApiKey,
            college_id: this.college_ID,
          })
          .finally(() => (this.loading = false))

        if (!result.data.status) {
          this.totalStudents = 0
          return
        }

        this.entranceYear = result.data.entranceYear
        const rows = result.data.rows || []

        // รวมยอดตามระดับชั้น (gradeNameTh) แบบไดนามิก — ไม่ fix จำนวนระดับชั้นตายตัว
        // เพื่อรองรับสถานศึกษาที่ไม่มีบางระดับชั้น (เช่น ไม่เปิดสอน ทล.บ.)
        const byGrade = {}
        let total = 0
        rows.forEach((r) => {
          const grade = r.gradeNameTh || 'ไม่ระบุระดับชั้น'
          const cnt = parseInt(r.cnt) || 0
          byGrade[grade] = (byGrade[grade] || 0) + cnt
          total += cnt
        })

        this.totalStudents = total
        const grades = Object.keys(byGrade)
        this.series = grades.map((g) => byGrade[g])
        this.chartOptions = {
          chart: {
            type: 'pie',
          },
          labels: grades.map((g) => g + ' : ' + this.numberWithCommas(byGrade[g])),
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.totalStudents = 0
      } finally {
        this.loading = false
      }
    },
  },

  computed: {
    college_ID(){
      return this.$route.query.college_ID
    }
  },

}
</script>
